<script>
export default {
  name: 'CpSocialMedia',
  components: {
    CpButtonLink: require('../../button-link').default,
  },
  directives: {
    margin: require('../../directives/margins').margin,
    marginTop: require('../../directives/margins').marginTop,
    marginRight: require('../../directives/margins').marginRight,
    marginBottom: require('../../directives/margins').marginBottom,
    marginLeft: require('../../directives/margins').marginLeft,
  },
  props: {
    official: Object,
  },
};
</script>

<template>
  <div class="socialMediaContainer">
    <CpButtonLink v-if="official.officeholder_facebook" openExternally :href="official.officeholder_facebook" link v-margin-right="0.5"
      ><i class="fab fa-facebook-f"></i
    ></CpButtonLink>
    <CpButtonLink v-if="official.officeholder_instagram" openExternally :href="official.officeholder_instagram" link v-margin-right="0.5"
      ><i class="fab fa-instagram"></i
    ></CpButtonLink>
    <CpButtonLink v-if="official.officeholder_tiktok" openExternally :href="official.officeholder_tiktok" link v-margin-right="0.5"
      ><svg xmlns="http://www.w3.org/2000/svg" width="13" height="15" viewBox="0 0 448 512">
        <path
          d="M448 209.9a210.1 210.1 0 0 1 -122.8-39.3V349.4A162.6 162.6 0 1 1 185 188.3V278.2a74.6 74.6 0 1 0 52.2 71.2V0l88 0a121.2 121.2 0 0 0 1.9 22.2h0A122.2 122.2 0 0 0 381 102.4a121.4 121.4 0 0 0 67 20.1z"
          fill="var(--primary-blue-600)"
        />
      </svg>
    </CpButtonLink>
    <CpButtonLink v-if="official.officeholder_x" openExternally :href="`https://x.com/${official.officeholder_x}`" link v-margin-right="0.5"
      ><svg width="13" height="15" viewBox="0 0 17 14" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
          d="M13.1009 0H15.5544L10.1943 6.77744L16.5 16H11.562L7.69492 10.4066L3.27013 16H0.815209L6.5483 8.75077L0.5 0H5.56188L9.05736 5.11262L13.1009 0ZM12.2399 14.3754H13.5993L4.82392 1.53928H3.36506L12.2399 14.3754Z"
          fill="var(--primary-blue-600)"
        /></svg
    ></CpButtonLink>
    <CpButtonLink v-if="official.officeholder_youtube" openExternally :href="official.officeholder_youtube" link><i class="fab fa-youtube"></i></CpButtonLink>
  </div>
</template>

<style scoped>
.socialMediaContainer {
  display: flex;
  justify-content: flex-end;
  align-items: center;
}

@media screen and (max-width: 768px) {
  .socialMediaContainer {
    justify-content: center;
  }
}
</style>
